import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';
import queryString from 'query-string';

// Loader Components
import showLoader from '@components/loader';

export const getTrips = createAsyncThunk('fencingSlice/getTrips', async (data) => {
    try {
        const query = queryString.stringify(data);

        showLoader(true);
        let response = await axios.get('/vehicle-trips?' + `&${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data.data.rows);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getSingleTrip = createAsyncThunk('fencingSlice/getSingleTrip', async (id) => {
    try {
        showLoader(true);
        let response = await axios.get('/vehicle-trips/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const fencingSlice = createSlice({
    name: 'fencingSlice',
    initialState: {
        data: [],
        tripData: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getTrips.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
    },
    extraReducers: (builder) => {
        builder.addCase(getSingleTrip.fulfilled, (state, action) => {
            state.tripData = action.payload;
            return;
        });
    }
});

export default fencingSlice.reducer;
